import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter);

const routes = [
  {
    path: '/',
    name: 'Top',
    component: () => import('../views/Top.vue')
  },
  {
    path: '/room/:id',
    name: 'Room',
    component: () => import('../views/Room.vue'),
  },
  {
    path: '/mypage',
    name: 'MyPage',
    component: () => import('../views/MyPage.vue'),
  },
  {
    path: '/mypage/list',
    name: 'MyPageList',
    component: () => import('../views/MyPageList.vue'),
  },
  {
    path: '/mypage/list/:id',
    name: 'MyPageList',
    component: () => import('../views/MyPageList.vue'),
  },
  {
    path: '/mypage/planboard',
    name: 'PlanBoard',
    component: () => import('../views/PlanBoard.vue'),
  },
  {
    path: '/error',
    name: 'Error',
    component: () => import('../views/Error.vue')
  },
  {
    path: '*',
    name: 'Error404',
    component: () => import('../views/Error404.vue')
  }
];

const router = new VueRouter({
  mode: 'history',
  routes,
  scrollBehavior() {
    return {x: 0, y: 0};
  }
});

export default router
